<template>
    <div class="menu-sorting">
        <div class="menu-group">
            <span class="menu-sorting-label">{{ __('Rendezés') }}:</span>
            <select
                id="orderby"
                name="orderby"
                v-model="rule"
            >
                <option
                    v-for="rule in rules"
                    :key="rule.id"
                    :value="rule.id">
                    {{ rule.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderRules',

    props: {
        rules: {
            type: Array,
            required: true,
        },

        selectedRule: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            rule: this.selectedRule
        }
    },

    watch: {
        rule() {
            this.$emit('update:selectedRule', this.rule)
        }
    },
}
</script>

<style scoped>

</style>
